import { render, staticRenderFns } from "./xmlTextModalCom.vue?vue&type=template&id=d2a1473c&"
import script from "./xmlTextModalCom.vue?vue&type=script&lang=js&"
export * from "./xmlTextModalCom.vue?vue&type=script&lang=js&"
import style0 from "./xmlTextModalCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports